import React from 'react';
import { Link } from 'react-router-dom';
import SiteNav from '../../components/site/SiteNav';
import SiteFooter from '../../components/site/SiteFooter';
import { Target, Heart, Zap, Coffee, Code, Users, ArrowRight, MapPin, Calendar } from 'lucide-react';
import Logo from '../../components/common/Logo';

const AboutUs = () => {
    const values = [
        { icon: Target, title: 'Hedef Odaklılık', desc: 'Her özellik, işletmelerin gerçek sorunlarını çözmek için tasarlanır.', color: '#0ea5e9' },
        { icon: Heart, title: 'Samimi Destek', desc: 'Teknik jargon değil, esnaf diliyle iletişim. Her işletme bizim için değerli.', color: '#ec4899' },
        { icon: Zap, title: 'Sürekli Gelişim', desc: 'Kullanıcı geri bildirimleriyle sürekli güncellenen, yaşayan bir platform.', color: '#f59e0b' },
    ];

    const milestones = [
        { date: '2026 Q1', title: 'Kuruluş', desc: 'fraxlabs İstanbul\'da kuruldu. ugra fikri doğdu.' },
        { date: '2026 Q2', title: 'Beta Lansmanı', desc: 'İlk işletmeler ugra\'yı kullanmaya başladı.' },
        { date: '2026 Q3', title: 'Pro & Premium', desc: '3 kademeli plan sistemi, AI danışman ve ödeme entegrasyonları.' },
        { date: '2026 Q4', title: 'Büyüme', desc: 'Ekosistem genişlemesi ve yeni entegrasyonlar.' },
    ];

    return (
        <div className="about-page" style={{ background: 'var(--bg-main)', color: 'var(--text-main)', minHeight: '100vh', overflowX: 'hidden' }}>
            <SiteNav />
            <style>{`
                .about-card { background: var(--bg-card); border: 1px solid var(--border); border-radius: 20px; padding: 2rem; transition: all 0.3s; }
                .about-card:hover { border-color: var(--primary); transform: translateY(-2px); }
                .timeline-item { display: flex; gap: 1.5rem; position: relative; }
                .timeline-dot { width: 12px; height: 12px; border-radius: 50%; background: var(--primary); flex-shrink: 0; margin-top: 6px; }
                @media (max-width: 768px) { .about-page section { padding-left: 5% !important; padding-right: 5% !important; } .about-grid { grid-template-columns: 1fr !important; } .story-grid { grid-template-columns: 1fr !important; } }
            `}</style>

            <section style={{ padding: '14rem 10% 4rem', textAlign: 'center' }}>
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'rgba(var(--primary-rgb), 0.1)', color: 'var(--primary)', padding: '8px 16px', borderRadius: 99, fontSize: '0.8125rem', fontWeight: 800, textTransform: 'uppercase', letterSpacing: 1.5, marginBottom: '1.5rem' }}>
                    <Coffee size={14} /> Hakkımızda
                </div>
                <h1 style={{ fontSize: 'clamp(2rem, 5vw, 3.5rem)', fontWeight: 900, letterSpacing: '-0.03em', marginBottom: '1rem' }}>Esnafın Dijital Ortağı</h1>
                <p style={{ color: 'var(--text-muted)', fontSize: '1.1rem', maxWidth: 600, margin: '0 auto' }}>ugra, yerel işletmelerin dijital dönüşümünü basit ve erişilebilir kılan bir fraxlabs ürünüdür.</p>
            </section>

            {/* Story */}
            <section style={{ padding: '0 10% 6rem' }}>
                <div className="story-grid" style={{ display: 'grid', gridTemplateColumns: '1.2fr 1fr', gap: '2rem', alignItems: 'start' }}>
                    <div className="about-card" style={{ padding: '3rem' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: '2rem' }}>
                            <Logo size={36} />
                            <div>
                                <div style={{ fontWeight: 900, fontSize: '1.5rem' }}>ugra</div>
                                <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)', fontWeight: 600 }}>by fraxlabs</div>
                            </div>
                        </div>
                        <p style={{ color: 'var(--text-muted)', lineHeight: 1.8, fontSize: '0.95rem', marginBottom: '1.5rem' }}>
                            2026 yılında İstanbul'da kurulan fraxlabs'in amiral gemisi ürünü olan ugra, kafe ve restoranların müşteri ilişkilerini dijitalleştirmek için geliştirildi.
                        </p>
                        <p style={{ color: 'var(--text-muted)', lineHeight: 1.8, fontSize: '0.95rem', marginBottom: '1.5rem' }}>
                            Geleneksel kağıt kartları, pahalı POS entegrasyonları ve karmaşık sadakat uygulamalarının yerine; QR kodla çalışan, web tabanlı, uygulama gerektirmeyen bir çözüm sunduk.
                        </p>
                        <p style={{ color: 'var(--text-muted)', lineHeight: 1.8, fontSize: '0.95rem' }}>
                            Bugün ugra; QR menü yönetimi, müşteri sadakati, sipariş takibi, stok-muhasebe, kampanya yönetimi ve AI destekli danışmanlık sunan kapsamlı bir işletme yönetim platformudur.
                        </p>
                        <div style={{ display: 'flex', gap: '1.5rem', marginTop: '2rem', flexWrap: 'wrap' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: 'var(--text-muted)', fontSize: '0.8rem', fontWeight: 600 }}>
                                <MapPin size={14} style={{ color: 'var(--primary)' }} /> İstanbul, Türkiye
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: 'var(--text-muted)', fontSize: '0.8rem', fontWeight: 600 }}>
                                <Calendar size={14} style={{ color: 'var(--primary)' }} /> 2026'dan beri
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        {values.map((v, i) => (
                            <div key={i} className="about-card" style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
                                <div style={{ width: 42, height: 42, borderRadius: 12, background: `${v.color}15`, color: v.color, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                    <v.icon size={20} />
                                </div>
                                <div>
                                    <h3 style={{ fontWeight: 800, fontSize: '1rem', marginBottom: '0.25rem' }}>{v.title}</h3>
                                    <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', lineHeight: 1.6 }}>{v.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Timeline */}
            <section style={{ padding: '6rem 10%', background: 'rgba(var(--primary-rgb), 0.02)' }}>
                <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
                    <h2 style={{ fontSize: '2rem', fontWeight: 900, marginBottom: '0.5rem' }}>Yolculuğumuz</h2>
                </div>
                <div style={{ maxWidth: 500, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                    {milestones.map((m, i) => (
                        <div key={i} className="timeline-item">
                            <div className="timeline-dot" />
                            <div>
                                <div style={{ fontSize: '0.75rem', fontWeight: 800, color: 'var(--primary)', textTransform: 'uppercase', marginBottom: '0.25rem' }}>{m.date}</div>
                                <h4 style={{ fontWeight: 800, marginBottom: '0.25rem' }}>{m.title}</h4>
                                <p style={{ color: 'var(--text-muted)', fontSize: '0.875rem', lineHeight: 1.6 }}>{m.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* CTA */}
            <section style={{ padding: '6rem 10%', textAlign: 'center' }}>
                <h2 style={{ fontSize: '2rem', fontWeight: 900, marginBottom: '1rem' }}>Vizyonumuz Hakkında Daha Fazlası</h2>
                <p style={{ color: 'var(--text-muted)', marginBottom: '2rem' }}>Teknik altyapımız ve geleceğe dair planlarımız için whitepaper'ımızı inceleyin.</p>
                <a href="https://docs.ugra.io/whitepaper" target="_blank" rel="noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'var(--primary)', color: 'white', padding: '1rem 2.5rem', borderRadius: 14, fontWeight: 800, textDecoration: 'none' }}>
                    Whitepaper'ı Oku <ArrowRight size={18} />
                </a>
            </section>

            <SiteFooter />
        </div>
    );
};

export default AboutUs;
